import React from 'react'
import * as AccessibleIconPrimitive from '@radix-ui/react-accessible-icon'

export default function AccessibleIcon (props) {
  return <AccessibleIconPrimitive.Root {...props} />
}
